import { SubscriptionStatus } from '../../models';

export const PAYMENT_ISSUES: SubscriptionStatus[] = ['past_due', 'unpaid'];

export const INACTIVE_STATE: SubscriptionStatus[] = [
  'canceled',
  'expired',
  'on_hold',
  'trial_expired',
  'paused',
];
